import { InjectionToken, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwiperDirective } from './swiper.directive';

export const SWIPER_ASSETS = new InjectionToken<{ scripts: string[]; styles: string[]; }>('SWIPER_ASSETS');
export const swiperAssetsDefaultConfig = {
  scripts: ['/assets/swiper/swiper-bundle.min.js'],
  styles: ['/assets/swiper/swiper-bundle.min.css']
};


/**
 * [swiper](https://swiperjs.com/get-started) 包裝模組，
 * 在引用套件的模組提供 SWIPER_ASSETS 這個依賴項目
 * ```typescript
 * {provide: SWIPER_ASSETS, useValue: {
 *   scripts: ['/assets/swiper/swiper-bundle.min.js'],
 *   styles:  ['/assets/swiper/swiper-bundle.min.css']
 * }}
 * ```
 */
@NgModule({
  declarations: [SwiperDirective],
  imports: [
    CommonModule
  ],
  exports: [
    SwiperDirective,
  ]
})
export class SwiperModule { }
